var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageBanner",style:('background:url(' +
    _vm.info.url +
    ');background-position: center;background-repeat: no-repeat;')},[_c('div',{staticClass:"bannerContain"},[_c('div',{staticClass:"container"},[_c('h2',[_vm._v(_vm._s(_vm.info.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.info.text))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d6cd901","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = null
// module chunks = 